// extracted by mini-css-extract-plugin
module.exports = {"card-link":"VendorCard_card-link__avdX9"};